import { configureStore } from "@reduxjs/toolkit";

// Data reducers
import currentEmployeeReducer from "./states/currentEmployeeSlice";
import currentEmployeeStatsReducer from "./states/currentEmployeeStatsSlice";
import currentEmployeeSalesReducer from "./states/currentEmployeeSalesSlice";
import employeesReducer from "./states/employeesSlice";
// Components reducers
import notificationReducer from "./states/notificationSlice";
import limitsAndUsedReducer from "./states/limitsAndUsedSlice";
import loungeReducer from "./states/loungeSlice";
import rolesReducer from "./states/rolesSlice";
import serviceReducer from "./states/serviceSlice";
import modulePermissionsReducer from "./states/modulePermissionsSlice";

export const store = configureStore({
  reducer: {
    currentEmployee: currentEmployeeReducer,
    currentEmployeeStats: currentEmployeeStatsReducer,
    currentEmployeeSales: currentEmployeeSalesReducer,
    employeesList: employeesReducer,
    notificationConfig: notificationReducer,
    limitsAndUsed: limitsAndUsedReducer,
    lounges: loungeReducer,
    roles: rolesReducer,
    services: serviceReducer,
    modulePermissions: modulePermissionsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppSelector = (state: RootState) => RootState;
